/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-08 11:07:36
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-16 16:19:30
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Collapse/index.tsx
 */
/**
 *   Collapse basic component.
 *  Author: Qiaofeng Deng
 *  CreatedAt: 2021-03-04
 */

import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import { mapLeftAnchorName, scroll } from '@/src/tools/helper';
import { withDraggableId } from './util';

import { EnumCollapseArrowMode } from 'src/types/common/common';
import styles from './style.module.less';
const ICON =
  'https://resource2.unifyxp.com/shopper-v2/pc/collapse_icon-right-new.svg';

type Props = {
  id: string;
  titleStyle?: React.CSSProperties;
  title: JSX.Element | string | number;
  content: JSX.Element;
  open?: boolean;
  openMargin?: number;
  bordered?: boolean;
  clickToExpand?: boolean;
  expandOffset?: number;
  onClickTrigger?: (vis: boolean) => void;
  err?: JSX.Element | string;
  titleContainerClassName?: string;
  contentClassName?: string;
  arrayPosition?: EnumCollapseArrowMode;
  collapseComponentTitleProps?: any;
  withoutCollapse?: boolean;
};

function Collapse({
  id,
  title,
  titleStyle,
  content,
  open,
  bordered,
  openMargin,
  clickToExpand,
  expandOffset,
  onClickTrigger,
  err,
  titleContainerClassName,
  contentClassName,
  arrayPosition = EnumCollapseArrowMode.back,
  collapseComponentTitleProps,
  withoutCollapse,
}: Props) {
  //console.log('collapseComponentTitleProps', collapseComponentTitleProps);
  const [vis, setVis] = useState<boolean>(open);
  const contentRef = useRef();

  const handleClicktitle = (e: React.MouseEvent) => {
    if (withoutCollapse) {
      return false;
    }
    // e.stopPropagation();
    setVis(!vis);
    if (id) scroll(mapLeftAnchorName(id));
    if (onClickTrigger) onClickTrigger(!vis);
  };

  useEffect(() => {
    setVis(open);
    return null;
  }, [open]);

  const titleClassName = React.useMemo(() => {
    if (arrayPosition === EnumCollapseArrowMode.front) {
      return styles.titleAtRight;
    }
    return styles.titleLeft;
  }, [arrayPosition]);

  return (
    <div
      id={id}
      className={classnames(styles.container)}
      style={{
        padding: clickToExpand ? (vis ? '0px' : `0 ${expandOffset}px`) : '',
        marginBottom: `${vis ? `${openMargin}px` : 0}`,
      }}>
      <div
        style={titleStyle}
        className={classnames(
          styles.title,
          withoutCollapse ? 'withoutCollapse' : '',
          titleContainerClassName,
          {
            [styles.bordered]: bordered,
          },
        )}
        onClick={handleClicktitle}
        {...(collapseComponentTitleProps || {})}>
        {arrayPosition === EnumCollapseArrowMode.front && (
          <div className={`${styles.titleRight} ${styles.iconAtLeft}`}>
            <img src={ICON} className={classnames({ [styles.rotate]: vis })} />
          </div>
        )}
        <div className={titleClassName}>{title}</div>
        {arrayPosition === EnumCollapseArrowMode.back && (
          <div className={styles.titleRight}>
            <img src={ICON} className={classnames({ [styles.rotate]: vis })} />
          </div>
        )}
      </div>
      <div
        ref={contentRef}
        className={`${classnames(styles.content, {
          [styles.contentVisible]: vis,
          [styles.contentDisplay]: !vis,
        })} ${contentClassName || ''}`}
        {...(open
          ? {}
          : {
              style: {
                overflow: 'hidden',
              },
            })}>
        {open && (err || null)}
        <div className={classnames(styles.contentContainer)}>{content}</div>
      </div>
      <div style={{ display: 'none' }}>{!open && (err || null)}</div>
    </div>
  );
}

export default withDraggableId(Collapse);
